import assetPath from '/opt/actions-runner/_work/crate/crate/packages/entity-pages/entity-pages-news/src/assets/emptystate.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')